import { defineStore } from 'pinia'
import { convertArrayToObject, mergeObjects } from 'src/utils'
import { NotifyMethods } from 'src/boot/notify'

export const usePaymentStore = defineStore('payment', {
  state: () => ({
    paymentMethods: {},
    loading: true,
  }),
  getters: {
    getPaymentMethodById(state) {
      return (paymentMethodId) => state.paymentMethods[paymentMethodId]
    },
  },
  actions: {
    async getAvailableMethods(params = {}) {
      try {
        this.loading = true

        let { data } = await this.$axiosInstance.get('/PaymentMethod', {
          params: {
            global: true,
            ...params,
          },
        })

        if (data?.success) {
          let paymentMethods = convertArrayToObject(
            data.data,
            'paymentMethodId'
          )
          this.paymentMethods = Object.assign({}, paymentMethods)
        }

        this.loading = false
      } catch (error) {}
    },
    async addPaymentMethod(address) {
      try {
        let { data } = await this.$axiosInstance.post('/PaymentMethod', address)

        if (data?.success) {
          let paymentMethods = convertArrayToObject(
            data.data,
            'paymentMethodId'
          )
          let newPaymentMethodId = null

          for (let key in paymentMethods) {
            if (!this.paymentMethods[key]) {
              newPaymentMethodId = key
              break
            }
          }

          this.paymentMethods = Object.assign({}, paymentMethods)

          return { ...data, newPaymentMethodId }
        }
      } catch (error) {
        return error
      }
    },
    async deletePaymentMethod(paymentMethod) {
      if (paymentMethod && paymentMethod.paymentMethodId) {
        try {
          let { data } = await this.$axiosInstance.delete(
            `/PaymentMethod/${paymentMethod.paymentMethodId}`
          )

          if (data && data.data) {
            delete this.paymentMethods[paymentMethod.paymentMethodId]
          }

          return data
        } catch (error) {
          return error
        }
      }
    },
    async updateDefaultPaymentMethod(paymentMethod) {
      try {
        let { data } = await this.$axiosInstance.put(
          `/PaymentMethod/SetDefault`,
          {
            paymentMethodId: paymentMethod.paymentMethodId,
          }
        )

        if (data?.data) {
          const resPaymentMethod = mergeObjects(paymentMethod, {
            isDefault: true,
          })
          this.addOrUpdatePaymentMethod(resPaymentMethod)
          NotifyMethods.showSuccess(
            'Default payment method modified successfully.'
          )
          return true
        }
        return false
      } catch (error) {
        NotifyMethods.showError(error.message)
        return false
      }
    },
    async updateBillingAddress({
      paymentMethodId,
      address,
      customerID = null,
    }) {
      try {
        let reqData = {
          customerAddressId: address.customerAddressesID,
        }
        if (customerID) reqData.customerID = customerID
        let { data } = await this.$axiosInstance.put(
          `/PaymentMethod/BillingAddress/${paymentMethodId}`,
          reqData
        )

        if (data?.success && data?.data === true) {
          let paymentMethod = this.getPaymentMethodById(paymentMethodId)
          if (paymentMethod?.paymentMethodId) {
            let updatedMethod = {
              ...paymentMethod,
              ['address']: {
                line1: address.line1,
                line2: address.line2,
                city: address.city,
                state: address.state,
                zip: address.zip,
                country: address.country,
                phone: address.phone,
                firstName: address.firstName,
                lastName: address.lastName,
                id: address.customerAddressesID,
              },
            }
            this.addOrUpdatePaymentMethod(updatedMethod)
          }

          return data
        }
      } catch (error) {
        return error
      }
    },
    async getUSAePayToken({ locationID, cardInfo }) {
      try {
        const { data } = await this.$axiosInstance.post(
          `/PaymentGateway/usaepay/tokenize/${locationID}`,
          cardInfo
        )

        return data
      } catch (error) {
        return error
      }
    },
    addOrUpdatePaymentMethod(paymentMethod) {
      if (paymentMethod.isDefault) {
        for (let key in this.paymentMethods) {
          this.paymentMethods[key].isDefault = false
        }
      }

      this.paymentMethods = Object.assign({}, this.paymentMethods, {
        [paymentMethod.paymentMethodId]: paymentMethod,
      })
    },
    setLoading(loading) {
      this.loading = loading
    },
    setField({ field, value }) {
      this[field] = value
    },
  },
})
